import React from 'react'

function DateGrayLine(props) {
  return (
    <div className="w-full px-4 pt-5 pb-2">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{props.date}</p>
    </div>
  )
}

export default DateGrayLine
